import { useContext, useEffect, useRef } from 'react';
import { CheckoutContext } from '@/contexts/CheckoutContext';

const safePostHogCall = (callback: () => void) => {
  try {
    if (typeof window !== 'undefined' && (window as any).posthog) {
      callback();
    }
  } catch (error) {
    // Silently fail to not break checkout
  }
};

export const usePostHogSessionReplay = () => {
  const { offer } = useContext(CheckoutContext);
  const hasInitializedRef = useRef(false);

  // const is3DSEnabled = offer?.threeDsEnabled && offer?.threeDsRetryEnabled;
  const is3DSEnabled = offer?.threeDsEnabled

  useEffect(() => {
    if (!offer) {
      console.log('[PostHog Session Replay] Aguardando offer...');
      return;
    }

    if (hasInitializedRef.current) {
      console.log('[PostHog Session Replay] Já inicializado, ignorando...');
      return;
    }

    hasInitializedRef.current = true;

    console.log('[PostHog Session Replay] Configurando...', {
      product_id: offer.product.short_id,
      threeds_enabled: !!offer.threeDsEnabled,
      threeds_retry_enabled: !!offer.threeDsRetryEnabled,
      is3DSEnabled
    });

    safePostHogCall(() => {
      const posthog = (window as any).posthog;
      if (is3DSEnabled) {
        console.log('[PostHog Session Replay] Iniciando gravação - 3DS ativo');
        posthog.startSessionRecording();
        posthog.capture('session_replay_started', {
          product_id: offer.product.short_id,
          threeds_enabled: !!offer.threeDsEnabled,
          threeds_retry_enabled: !!offer.threeDsRetryEnabled
        });
      } else {
        console.log('[PostHog Session Replay] Parando gravação - 3DS inativo');
        posthog.stopSessionRecording();
      }
    });
  }, [offer, is3DSEnabled]);

  useEffect(() => {
    return () => {
      safePostHogCall(() => {
        console.log('[PostHog Session Replay] Cleanup - parando gravação');
        const posthog = (window as any).posthog;
        posthog.stopSessionRecording();
      });
    };
  }, []);
};
